import React, { Component } from "react"
import Modal from "react-modal"
import { connect } from "react-redux"
import {
  payWithPelecard,
  payWithPelecardToken,
  resetPaymentToTryAgain,
  saveCreditTokenInServer,
} from "../../../actions"
import ManualEnter from "../../../assets/svg/enter_credit_card.svg"
import NewCard from "../../../assets/svg/new_credit_card.svg"
import SavedCard from "../../../assets/svg/saved_credit_card.svg"
import {
  OrangeButton,
  PendingSuccessFailBtn,
  WhiteCheckBox,
  WhiteLabel,
} from "../../common"
import PaymentInput from "../../common/PaymentInput"
import { CardManuallyInputs } from "../../reduxified"
import "./style.css"

class PaymentModal1 extends Component {
  constructor(props) {
    super(props)

    this.INIT_STATE = {
      enterCardDataManually: false,
      showChoiceBtns: true,
    }

    this.state = this.INIT_STATE
  }

  getTitleFromReqState() {
    const { showChoiceBtns, enterCardDataManually } = this.state
    const {
      loadingRequest,
      paymentFailed,
      paymentSuccess,
      pay_modal_swipe_title,
      pay_modal_pls_wait_while_loading,
      payment_error,
      payment_success,
      payment_pick_your_option,
      payment_payment_details,
    } = this.props

    if (loadingRequest) {
      return pay_modal_pls_wait_while_loading
    }

    if (paymentFailed) {
      // return err_title_text;
      return payment_error
    }

    if (paymentSuccess) {
      return payment_success
    }

    if (showChoiceBtns) {
      return payment_pick_your_option
    }

    if (!enterCardDataManually) {
      return pay_modal_swipe_title
      //return '';
    }

    if (enterCardDataManually) {
      return payment_payment_details
    }
  }

  renderCloseBtn(show) {
    if (!show) {
      return
    }

    const { close_text } = this.props

    return (
      <OrangeButton
        extraClass="payment-modal-close-btn"
        onClick={() => {
          this.props.onCloseModalClick()
          this.onTryAgainClicked()
        }}
      >
        {close_text}
      </OrangeButton>
    )
  }

  renderPayWithExistingTokenBtn(show) {
    if (!show) {
      return
    }

    const { userTokenInServer, payment_pay_with_last_payment_details } =
      this.props

    if (!userTokenInServer) {
      return
    }

    return (
      <button
        className="payment-method-btn"
        onClick={(e) => this.onPayWithSavedTokenClick()}
      >
        <img src={SavedCard} alt="saved-card" />
        {payment_pay_with_last_payment_details}
      </button>
    )
  }

  renderPaymentInputMagnetOrManualButtons(show) {
    // show = !loadingRequest && !paymentFailed && !paymentSuccess;
    if (!show) {
      return
    }

    const { showChoiceBtns } = this.state

    if (showChoiceBtns) {
      return this.renderPaymentMenu(show)
    }

    return this.renderPaymentInputMagnetOrManual(show)
  }

  renderPaymentMenu(show) {
    const { payment_swipe_a_card, payment_for_manual_input } = this.props

    return (
      <>
        {this.renderPayWithExistingTokenBtn(show)}

        <button
          className="payment-method-btn"
          onClick={(e) =>
            this.setState({
              showChoiceBtns: false,
              enterCardDataManually: false,
            })
          }
        >
          <img src={NewCard} alt="new-card" />
          {payment_swipe_a_card}
        </button>
        <button
          className="payment-method-btn"
          onClick={(e) =>
            this.setState({
              showChoiceBtns: false,
              enterCardDataManually: true,
            })
          }
        >
          <img src={ManualEnter} alt="manual-enter" />
          {payment_for_manual_input}
        </button>
      </>
    )
  }

  renderPaymentInputMagnetOrManual(show) {
    if (!show) {
      return
    }

    const { enterCardDataManually } = this.state
    const { payment_for_manual_input_click_here } = this.props

    if (!enterCardDataManually) {
      return (
        <div className="paymdl2-payinput-wrapper">
          <PaymentInput
            onPaymentDataReady={this.startPayingProcess.bind(this)}
          />
        </div>
      )
    }

    return this.renderManuallyInputs()
  }

  closeEnterCardDataManually() {
    this.setState(this.INIT_STATE)
  }

  renderManuallyInputs() {
    return (
      <CardManuallyInputs
        show={this.state.enterCardDataManually}
        startPayingProcess={(creditCardData, dateMMYY) =>
          this.startPayingProcess(creditCardData, dateMMYY)
        }
        closeEnterCardDataManually={() => this.closeEnterCardDataManually()}
      />
    )
  }

  startPayingProcess(creditCardData, dateMMYY) {
    const { loadingRequest } = this.props
    if (loadingRequest) {
      console.log(
        "PaymentModal1: (for orderId ${orderId}) Try for new payment request aborted. Can't start new payment before currrent fineshed. Please, wait..."
      )
      return
    }

    const { total, orderId } = this.props
    this.props.payWithPelecard(
      creditCardData,
      dateMMYY,
      "id",
      "cvv",
      total,
      orderId
    )
  }

  onPayWithSavedTokenClick() {
    const { userTokenInServer, total, orderId } = this.props
    this.props.payWithPelecardToken(userTokenInServer, total, orderId)
  }

  renderRequestStateSpinnerAndResultButtons(show) {
    if (!show) {
      return
    }

    const {
      loadingRequest,
      paymentFailed,
      paymentSuccess,
      showTryAgain,
      showConnectionErrMsg,
      ok_text,
    } = this.props

    const currOkBtnStatus = loadingRequest
      ? 0
      : paymentFailed
      ? -1
      : paymentSuccess
      ? 1
      : 0
    const statusClass = loadingRequest
      ? " status-loading-request"
      : paymentFailed
      ? " status-payment-failed"
      : paymentSuccess
      ? " status-payment-success"
      : " status-other"
    return (
      <div
        className={"error-or-success-content payment-version-1" + statusClass}
      >
        <PendingSuccessFailBtn
          status={currOkBtnStatus}
          onBtnClick={() => this.onOkClicked()}
        >
          {ok_text}
        </PendingSuccessFailBtn>

        {this.renderTryAgainBtn(showTryAgain)}
        {this.renderConnectionErrMsg(showConnectionErrMsg)}
        {this.renderSuccessSaveTokenCheckboxContinueBtn(paymentSuccess)}
      </div>
    )
  }

  renderSuccessSaveTokenCheckboxContinueBtn(show) {
    if (!show) {
      return
    }

    const {
      userTokenInServer,
      pelecardToken,
      payment_press_for_locker_opening,
    } = this.props

    return (
      <div>
        {this.renderSaveMyNewTokenCheckBox(userTokenInServer !== pelecardToken)}

        <OrangeButton
          activable
          extraClass="paymdl2-fade-in paymdl2-err-btn"
          onClick={() => this.onSuccessfulPaymentContinueBtnClick()}
        >
          {payment_press_for_locker_opening}
        </OrangeButton>
      </div>
    )
  }

  renderSaveMyNewTokenCheckBox(show) {
    if (!show) {
      return
    }

    const { saveCardPeleToken } = this.state
    const { payment_save_payment_details_for_future_use, dirRtl } = this.props

    return (
      <div className="paymdl2-fade-in paymdl2-save-token-wrap paymdl2-err-msg">
        <WhiteCheckBox
          checked={saveCardPeleToken}
          onChange={(e) =>
            this.setState({ saveCardPeleToken: e.target.checked })
          }
        />

        <WhiteLabel dirRtl={dirRtl}>
          {payment_save_payment_details_for_future_use}
        </WhiteLabel>
      </div>
    )
  }

  renderTryAgainBtn(show) {
    if (!show) {
      return
    }

    const { pay_modal_click_to_retry, payment_input_error, dirRtl } = this.props
    const {
      loadingRequest,
      paymentFailed,
      paymentSuccess,
      showConnectionErrMsg,
    } = this.props

    let statusClass = loadingRequest
      ? " status-loading-request"
      : paymentFailed
      ? " status-payment-failed"
      : paymentSuccess
      ? " status-payment-success"
      : " status-other"
    statusClass = showConnectionErrMsg
      ? statusClass + " connection-error"
      : statusClass
    return (
      <div
        className={"error-or-success-content payment-version-1" + statusClass}
      >
        <WhiteLabel
          extraClass="paymdl2-fade-in paymdl2-err-msg"
          dirRtl={dirRtl}
        >
          {payment_input_error}
        </WhiteLabel>

        <OrangeButton
          activable
          extraClass="paymdl2-fade-in paymdl2-err-btn"
          onClick={() => this.onTryAgainClicked()}
        >
          {pay_modal_click_to_retry}
        </OrangeButton>
      </div>
    )
  }

  onTryAgainClicked() {
    this.setState({ ...this.INIT_STATE })
    this.props.resetPaymentToTryAgain()
  }

  renderConnectionErrMsg(show) {
    if (!show) {
      return
    }

    const { pay_modal_network_err, pay_modal_click_to_retry, dirRtl } =
      this.props

    const {
      loadingRequest,
      paymentFailed,
      paymentSuccess,
      //showConnectionErrMsg,
    } = this.props

    let statusClass = loadingRequest
      ? " status-loading-request"
      : paymentFailed
      ? " status-payment-failed"
      : paymentSuccess
      ? " status-payment-success"
      : " status-other"
    statusClass += " connection-error"
    return (
      <div
        className={"error-or-success-content payment-version-1" + statusClass}
      >
        <WhiteLabel
          extraClass="paymdl2-fade-in paymdl2-err-msg"
          dirRtl={dirRtl}
        >
          {pay_modal_network_err}
        </WhiteLabel>
        <OrangeButton
          onClick={() => this.onTryAgainClicked()}
          // extraClass="paymdl2-fade-in paymdl2-err-btn"
        >
          {pay_modal_click_to_retry}
        </OrangeButton>
      </div>
    )
  }

  onContinueBtnClick() {
    this.props.onPaymentNetworkFail()
  }

  onSuccessfulPaymentContinueBtnClick() {
    const { saveCardPeleToken } = this.state
    const { userId, pelecardToken } = this.props

    if (saveCardPeleToken && pelecardToken) {
      this.props.saveCreditTokenInServer(userId, pelecardToken)
    }

    this.props.onUserPaymentSuccess()
  }

  render() {
    const { show } = this.props

    if (!show) {
      return <noscript />
    }
    const { enterCardDataManually } = this.state
    const { loadingRequest, paymentFailed, paymentSuccess, dirRtl } = this.props

    const showPaymentInputs =
      !loadingRequest && !paymentFailed && !paymentSuccess

    const wrapperClassName = `paymdl2-modal-wrap ${
      dirRtl ? "dirrtl" : "dirltr"
    }`

    return (
      <Modal
        extraClass={wrapperClassName}
        isOpen={show}
        onRequestClose={() => {
          this.props.onCloseModalClick()
          this.onTryAgainClicked()
        }}
        className={`react-modal-content medium-react-modal ${
          enterCardDataManually ? "payment-modal-move-up" : ""
        }`}
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <div className="payment-modal-title">{this.getTitleFromReqState()}</div>
        <div className="payment-btns">
          {this.renderPaymentInputMagnetOrManualButtons(showPaymentInputs)}
        </div>

        {this.renderRequestStateSpinnerAndResultButtons(!showPaymentInputs)}

        {this.renderCloseBtn(
          !loadingRequest &&
            !paymentSuccess &&
            !this.props.showTryAgain &&
            !this.state.enterCardDataManually
        )}
      </Modal>
    )
  }
}

const mapStateToProps = ({ userLogin, paymentModal, translate }) => {
  const { userId, creditCardToken, authenticated } = userLogin
  const {
    loadingRequest,
    paymentFailed,
    paymentSuccess,
    showTryAgain,
    showConnectionErrMsg,
    pelecardToken,
  } = paymentModal

  const {
    dirRtl,
    ok_text,
    close_text,
    pay_modal_swipe_title,
    pay_modal_pls_wait_while_loading,
    pay_modal_click_to_retry,
    pay_modal_network_err,
    continue_text,
    payment_error,
    payment_success,
    payment_pick_your_option,
    payment_payment_details,
    payment_pay_with_last_payment_details,
    payment_swipe_a_card,
    payment_for_manual_input,
    payment_for_manual_input_click_here,
    payment_credit_card_number,
    payment_month,
    payment_year,
    payment_approval,
    payment_swipe_a_card_click_here,
    payment_press_for_locker_opening,
    payment_save_payment_details_for_future_use,
    payment_input_error,
  } = translate

  return {
    userId,
    loadingRequest,
    paymentFailed,
    paymentSuccess,
    showTryAgain,
    showConnectionErrMsg,
    pelecardToken,
    userTokenInServer: creditCardToken,
    authenticated,
    dirRtl,
    ok_text,
    close_text,
    pay_modal_swipe_title,
    pay_modal_pls_wait_while_loading,
    pay_modal_click_to_retry,
    pay_modal_network_err,
    continue_text,
    payment_error,
    payment_success,
    payment_pick_your_option,
    payment_payment_details,
    payment_pay_with_last_payment_details,
    payment_swipe_a_card,
    payment_for_manual_input,
    payment_for_manual_input_click_here,
    payment_credit_card_number,
    payment_month,
    payment_year,
    payment_approval,
    payment_swipe_a_card_click_here,
    payment_press_for_locker_opening,
    payment_save_payment_details_for_future_use,
    payment_input_error,
  }
}

export default connect(mapStateToProps, {
  payWithPelecard,
  payWithPelecardToken,
  resetPaymentToTryAgain,
  saveCreditTokenInServer,
})(PaymentModal1)
